import React, { useRef, useEffect} from 'react';
import '../ContactPage/Styles.css';
import useTitle from '../../useTitle';
import ContactSection from '../ContactSection/Index';

const ContactPage = () => {
  useTitle("Contact");

  const formRef = useRef(null);
  const selectRef = useRef(null);
  const captchaRef = useRef(null);

  useEffect(() => {
    const formElement = formRef.current;
    const selectElement = selectRef.current;

    if (formElement) formElement.reset();
    if (selectElement) selectElement.selectedIndex = 0;

    const handleSubmit = (e) => {
      const hCaptcha = formElement.querySelector('textarea[name="h-captcha-response"]')?.value;
      if (!hCaptcha) {
        e.preventDefault();
        alert("Gelieve de captcha in te vullen.");
      }
    };

    formElement.addEventListener('submit', handleSubmit);

    const loadCaptchaScript = () => {
      const script = document.createElement('script');
      script.src = 'https://web3forms.com/client/script.js';
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);

      script.onload = () => {
        if (captchaRef.current && window.hcaptcha) {
          window.hcaptcha.render(captchaRef.current);
        }
      };
    };

    loadCaptchaScript();

    const handlePageShow = (event) => {
      const isBack = event.persisted || performance.getEntriesByType("navigation")[0]?.type === "back_forward";

      if (isBack) {
        if (formRef.current) formRef.current.reset();
        if (selectRef.current) selectRef.current.selectedIndex = 0;
        window.location.reload();

        // Verwijder handmatig verlopen hCaptcha token
        const oldToken = formRef.current?.querySelector('textarea[name="h-captcha-response"]');
        if (oldToken) oldToken.remove();

        // Reset hCaptcha widget
        if (window.hcaptcha && captchaRef.current) {
          window.hcaptcha.reset();
        }
      }
    };

    window.addEventListener("pageshow", handlePageShow);

    return () => {
      formElement.removeEventListener('submit', handleSubmit);
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, []);
  return (
    <>
      <div className='contactPageContainer'>
          <div className='contactTitleContainer'>
            <h1 className='contactTitle'>Contact formulier</h1>
          </div>
          <div className='contactTitleDescription'>
            <p>Heb je vragen over mijn yogalessen, workshops of iets anders? Ik sta klaar om je te helpen! Vul het formulier hieronder in en ik beantwoord je vraag zo snel mogelijk. Namasté!</p>
          </div>

          <div className='formulierContact'>
            <form ref={formRef} action="https://api.web3forms.com/submit" method="POST">
              <input type="hidden" name="access_key" value="e1f68a11-5db3-4a40-937c-c0464837cd8b" />
              <input type="hidden" name="subject" value="New Submission for Mindful Breaks" />
              <input type="hidden" name="from_name" value="Mindful Breaks" />
              <input type="hidden" name="redirect" value="https://www.mindfulbreaks.be/bedankt" />
              <input type="checkbox" name="botcheck" className="hidden" style={{ display: 'none' }} />

              <label htmlFor="fname">Naam en Voornaam<span className="required"> *</span></label>
              <input type="text" id="fname" name="Naam en Voornaam" placeholder='Typ hier je naam en voornaam in...' required />

              <label htmlFor="emailadres">E-mailadres<span className="required"> *</span></label>
              <input type="email" id="emailadres" name="email" placeholder='Typ hier je e-mailadres in...' required />

              <label htmlFor="Telefoonnummer">Telefoonnummer<span className="required"> *</span></label>
              <input type="text" id="Telefoonnummer" name="Telefoonnummer" placeholder='Typ hier je telefoonnummer in...' required />

              <label htmlFor="Onderwerp">Onderwerp<span className="required"> *</span></label>
              <select className="form-control onderwerp-menu" name="Onderwerp" ref={selectRef} required>
                <option disabled hidden>Selecteer een onderwerp...</option>
                <option>Privélessen</option>
                <option>Yoga voor bedrijven</option>
                <option>Boek een les</option>
                <option>Workshop</option>
                <option>Samenwerking</option>
                <option>Anders</option>
              </select>

              <label htmlFor="exampleFormControlTextarea1">Reden<span className="required">*</span></label>
              <textarea className="form-control reden" id="exampleFormControlTextarea1" rows="3" placeholder='Typ hier je bericht in...' name="Reden" required></textarea>

              <label className='privacybeleidContainer' htmlFor="privacyConsent">
                Ik ga akkoord met de verwerking van mijn gegevens zoals beschreven in het
                <a href="/files/Mindful-Breaks-Privacyverklaring.pdf" target="_blank" className='privacyBeleid'>privacybeleid</a>
                <input type="checkbox" id="privacyConsent" name="Privacy Consent" required />
              </label>

              <div
                className="h-captcha"
                data-captcha="true"
                data-lang="en"
                data-theme="light"
                data-size="normal"
                aria-required="true"
                data-sitekey="50b2fe65-b00b-4b9e-ad62-3ba471098be2"
                ref={captchaRef}
              ></div>

              <input type="submit" value="VERZENDEN" />
            </form>
          </div>
      </div>


      {/* Contact/Menu Section */}
      <ContactSection />
    </>
  )
}

export default ContactPage;